module.exports = __webpack_public_path__ + "img/man_face.a37dafb0.png";